import React, { useState } from "react";
import ListItem from "@mui/material/ListItem";
import ListItemAvatar from "@mui/material/ListItemAvatar";
import ListItemText from "@mui/material/ListItemText";
import Tooltip from "@mui/material/Tooltip";
import ListItemIcon from "@mui/material/ListItemIcon";
import { Typography } from "@mui/material";

import FavoriteButton from "./FavoriteButton";

const ListItemRecent = ({
  id,
  classes,
  date,
  handleClickPrimaryText,
  resource,
  number: i,
  description = "",
  textPrimary = "",
}) => {
  const [show, setShow] = useState(false);

  const handleOnMouseEnter = (e) => {
    e.preventDefault();
    setShow(true);
  };
  const handleOnMouseLeave = (e) => {
    e.preventDefault();
    setShow(false);
  };

  return (
    <ListItem
      key={`List-Item-${i}`}
      className={classes.textItem}
      component={"div"}
      onMouseLeave={handleOnMouseLeave}
      onMouseOver={handleOnMouseEnter}
    >
      <ListItemAvatar key={`List-image-${i}`}>
        <img
          key={`Img-${i}`}
          alt="icon-reports"
          height={25}
          src={`${process.env.PUBLIC_URL}/reports-icon-2.png`}
          width={30}
        />
      </ListItemAvatar>
      <Tooltip key={`Tooltip-r-${i}`} title={`Go to ${resource}`}>
        <ListItemText
          key={`List-itemText-Path-${i}`}
          color="textPrimary"
          primary={textPrimary}
          primaryTypographyProps={{
            style: {
              cursor: "pointer",
              width: 400,
            },
            onClick: handleClickPrimaryText,
          }}
        />
      </Tooltip>
      {description && (
        <ListItemText
          primary={
            <Typography noWrap color="textSecondary" variant="caption">
              {description}
            </Typography>
          }
        />
      )}
      <ListItemText
        key={`List-Item-Text-Date-${i}`}
        color="textPrimary"
        primary={date}
        primaryTypographyProps={{
          style: {
            width: 180,
            marginRight: 15,
            textAlign: "right",
            marginLeft: "auto",
          },
        }}
      />
      {show ? (
        <FavoriteButton key={`FavoriteButton-Recent-${i}`} className={classes.star} id={id} />
      ) : (
        <ListItemIcon />
      )}
    </ListItem>
  );
};

export default ListItemRecent;
